// Canonical JSON: keys sorted, no whitespace. The signed material for the manifest,
// snapshot sections and point-lookup proofs. Canonicalisation has to be decidable on
// both sides, or a valid signature would sometimes fail depending on field order in
// the response. This is the exact algorithm of `server/tools/flow-test.mjs` and of
// the Dart client's ThresholdSignatures.canonical.

export function canonical(value: unknown): string {
  if (value === null || typeof value !== 'object') {
    const text = JSON.stringify(value);
    if (text === undefined) {
      // undefined / functions never appear in parsed JSON; hitting this is a
      // programming error, not bad wire data.
      throw new TypeError('canonical() got a value JSON cannot represent');
    }
    return text;
  }
  if (Array.isArray(value)) {
    return `[${value.map(canonical).join(',')}]`;
  }
  const record = value as Record<string, unknown>;
  const keys = Object.keys(record).sort();
  return `{${keys.map((k) => `${JSON.stringify(k)}:${canonical(record[k])}`).join(',')}}`;
}
